import React from 'react';
import {
  TouchableOpacity, Text, View, StyleSheet,
} from 'react-native';
import Colors from '../../constants/Colors';
import LeftArrow16 from '../16pxIcons/LeftArrow16';
import isMobile from '../IsMobile';

interface ProfileSectionHeaderProps {
  title: string,
  back: () => void,
}

const ProfileSectionHeader = ({ title, back }
  : ProfileSectionHeaderProps) => <View style={styles.container}>
    {isMobile && <TouchableOpacity
      onPress={back}
      style={styles.backButton}
    >
      <LeftArrow16 />
    </TouchableOpacity>}
    <Text style={styles.title}>{title}</Text>
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 24,
  },
  backButton: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue500,
    backgroundColor: '#FFF',
    marginEnd: 16,
  },
  title: {
    fontSize: isMobile ? 20 : 22,
    lineHeight: isMobile ? 30 : 33,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
});

export default ProfileSectionHeader;
